import RESOURCE_PERMISSIONS from './resourcePermissionType';

export const RESOURCE_PERMISSIONS_MAP = {
  [RESOURCE_PERMISSIONS.ATL]: {
    Value: RESOURCE_PERMISSIONS.ATL,
    Label: 'ATL'
  },
  [RESOURCE_PERMISSIONS.ATM]: {
    Value: RESOURCE_PERMISSIONS.ATM,
    Label: 'ATM'
  },
  [RESOURCE_PERMISSIONS.SPONSOR_COORDINATOR]: {
    Value: RESOURCE_PERMISSIONS.SPONSOR_COORDINATOR,
    Label: 'Sponsor / Coordinator'
  },
  [RESOURCE_PERMISSIONS.FDA_ADMIN_REVIEWER]: {
    Value: RESOURCE_PERMISSIONS.FDA_ADMIN_REVIEWER,
    Label: 'FDA Admin / Reviewer'
  },
  [RESOURCE_PERMISSIONS.VIP_PARTNER]: {
    Value: RESOURCE_PERMISSIONS.VIP_PARTNER,
    Label: 'VIP Partner'
  },
  [RESOURCE_PERMISSIONS.VIP_FREE_LICENSE]: {
    Value: RESOURCE_PERMISSIONS.VIP_FREE_LICENSE,
    Label: 'Free License Users'
  }
};
